// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yoif","controls":"styles_controls__141Bx","charLimit":"styles_charLimit__OB_XS","input":"styles_input__3b-dX","send":"styles_send__iVXdT"};